jQuery(document).ready(function($) {
    'use strict';

    let isFirstTime = true;

    $('.composite_data').on('wc-composite-initializing', initializing);

    function initializing(_, composite) {
        composite.actions.add_action(
            'component_selection_changed',
            componentSelectionChanged,
        );
    }

    function componentSelectionChanged(component) {
        const $flyoutToggleButton = component.$el.find(
            '.component_title_wrapper .sp-flyout-toggle > span',
        );
        const $swatchComponent = component.$el.find(
            '.select-option.selected .swatch-anchor',
        );
        const $radioComponent = component.$el.find('.radio-option:checked');

        const hasComponent = !!component.get_selected_product();

        if (hasComponent) {
            $flyoutToggleButton.text('Ändra');
            if (isFirstTime) {
                isFirstTime = false;
                $swatchComponent.trigger('click');
            }
            
            $radioComponent.trigger('change');
        } else {
            $flyoutToggleButton.text('Lägg till');
        }
    }
});
